import { CircularProgress, Typography } from '@epilot/concorde-elements'
import { useTranslation } from 'react-i18next'

import classes from './ProductDetailsChart.module.scss'

export const ChartPlaceholder = ({
  status
}: {
  status: 'loading' | 'error'
}) => {
  const { t } = useTranslation()

  return (
    <div className={classes.chartPlaceholder}>
      {status === 'loading' ? (
        <CircularProgress />
      ) : (
        <Typography variant="error">
          {t(
            'price_chart.loading_error',
            'Unable to load market data. Please try again later.'
          )}
        </Typography>
      )}
    </div>
  )
}
